module.exports = __webpack_public_path__ + "officialStatic/img/talent-bg.a0e97d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/talent-bg.png
// module id = fnoP
// module chunks = 0